import styled from 'styled-components/macro';
import { SecondPart } from '../../interfaces/buildings';
import { createRef } from 'react';
import { HotspotConfig } from '../../config/cityFr';
import { getOffsetPosition } from '../../components/utils/position';
import { useStore } from '../../components/store';
import { useHistory } from 'react-router-dom';

const StyledArrow = styled.div<{ x: number; y: number; direction: number; color?: string }>`
    position: absolute;
    cursor: pointer;
    width: 5%;
    height: 12%;
    top: ${(props) => props.y}px;
    left: ${(props) => props.x}px;
    transform: rotate(${(props) => props.direction}deg);
    background: ${(props) => props.color || '#fff'};
    clip-path: polygon(0% 40%, 50% 0, 100% 40%, 70% 40%, 70% 100%, 30% 100%, 30% 40%);

    animation: arrowAnimation-${(props) => props.direction} 3s ease-in-out 1s infinite ;

    @keyframes arrowAnimation-${(props) => props.direction} {
        0% {
            transform: scale(1) rotate(${(props) => props.direction}deg);
            }
        50% {
            transform: scale(1.1) rotate(${(props) => props.direction}deg);
        }
        100% {
            transform: scale(1) rotate(${(props) => props.direction}deg);
        }
    }
`;

const SecondPartArrow = ({
    direction,
    config
}: SecondPart) => {
    const { state } = useStore();
    const history = useHistory();
    const containerRef = createRef<HTMLDivElement>();

    const handleHotspotClick = (config: HotspotConfig, pos: {left: string, top: string}) => {
        if (config.type !== 'inactive') {
            openBuilding(config.link || config.building, `${pos.left} ${pos.top}`)
        }
    }
    const openBuilding = (path: string, coords: string) => {
        if (containerRef.current) {
            containerRef.current.style.transformOrigin = coords;
        }
        history.push(`/${path}`);
    };

    const pos = getOffsetPosition({
        ...config.coordinates,
        imgWidth: state.appDimensions.width,
        imgHeight: state.appDimensions.height,
    })

    let arrowDirection;
    switch (direction) {
        case 'Up':
            arrowDirection = 0;
            break;
        case 'Down':
            arrowDirection = 180;
            break;
        case 'Left':
            arrowDirection = -90;
            break;
        case 'Right':
            arrowDirection = 90;
            break;
    }

    return (
        <>
            <StyledArrow
                x={config.coordinates.x}
                y={config.coordinates.y}
                direction={arrowDirection}
                onClick={() =>  handleHotspotClick(config, pos) } />
        </>
    );
};

export default SecondPartArrow;
